module.exports = __webpack_public_path__ + "static/media/S1N12-4.ef0db7af.svg";